import Controller from "@ember/controller"
import { inject as service } from "@ember/service"
import hasMany from "cc-frontend/helpers/has-many"

export default class GroupController extends Controller {
  @service("ember-store")
  store

  @service
  session

  @hasMany("model", "group", "ancestors")
  ancestors
}
